import { useState } from "react";
import {
  Box, Button, TextField, Paper, InputAdornment, Typography, IconButton
} from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import LockIcon from "@mui/icons-material/Lock";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { useNavigate } from "react-router-dom";
import Logo from "../Images/logo1.png";

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPass, setShowPass] = useState(false);

  const [error, setError] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    if (!email || !password) {
      setError("Please fill all fields");
      return;
    }

    try {
      const res = await fetch("https://api.hr-ebnhaian.cloud/api/v1/auth/login", {
        method: "POST",
        headers: { "Content-type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      const result = await res.json();

      if (result.token && result.data) {
        localStorage.setItem("token", result.token);
        localStorage.setItem("user", JSON.stringify(result.data));
        localStorage.setItem("userRole", result.data.role);

        navigate("/");
      } else {
        setError("Incorrect email or password");
      }
    } catch (error) {
      setError("Server error, please try again");
    }
  };

  return (
    <Box display="flex" justifyContent="center" alignItems="center" height="100vh" bgcolor="#f5f5f5">
      <Paper
        elevation={3}
        sx={{ p: 4, width: "100%", maxWidth: 400, bgcolor: "rgb(57 80 112)" }}
      >
        <Box textAlign="center" mb={2}>
          <img
            src={Logo}
            alt="Logo"
            style={{ width: "120px", height: "120px", objectFit: "contain" }}
          />
        </Box>

        {/* 🔥 رسالة خطأ */}
        {error && (
          <Typography color="error" textAlign="center" fontSize="14px" mb={1}>
            {error}
          </Typography>
        )}

        <form onSubmit={handleLogin}>
          {/* Email */}
          <TextField
            fullWidth
            label="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            variant="outlined"
            margin="normal"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <EmailIcon style={{ color: "white" }} />
                </InputAdornment>
              ),
              style: { color: "white" },
            }}
            InputLabelProps={{ style: { color: "white" } }}
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": { borderColor: "white" },
                "&:hover fieldset": { borderColor: "white" },
                "&.Mui-focused fieldset": { borderColor: "white" },
              },
            }}
          />

          {/* Password */}
          <TextField
            fullWidth
            label="Password"
            type={showPass ? "text" : "password"}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            variant="outlined"
            margin="normal"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <LockIcon style={{ color: "white" }} />
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={() => setShowPass(!showPass)}>
                    {showPass ? <VisibilityOff sx={{ color: "white" }} /> : <Visibility sx={{ color: "white" }} />}
                  </IconButton>
                </InputAdornment>
              ),
              style: { color: "white" },
            }}
            InputLabelProps={{ style: { color: "white" } }}
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": { borderColor: "white" },
                "&:hover fieldset": { borderColor: "white" },
                "&.Mui-focused fieldset": { borderColor: "white" },
              },
            }}
          />

          {/* Sign in button */}
          <Button
            fullWidth
            type="submit"
            variant="contained"
            sx={{ mt: 2, backgroundColor: "#1565c0", color: "white" }}
          >
            Login
          </Button>

          {/* Forgot password */}
          <Button
            fullWidth
            onClick={() => navigate("/forgot-password")}
            sx={{
              mt: 1,
              color: "white",
              textTransform: "none",
              fontSize: "14px",
              textDecoration: "underline",
            }}
          >
            Forgot your password?
          </Button>

          {/* Change password (NEW) */}

        </form>
      </Paper>
    </Box>
  );
};

export default Login;
